<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('income_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
            <router-link to="/import/income" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('import')}}
            </router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('sale_invoice_no')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div style="display: flex; justify-content: space-between;">
                        <div>
                            <div style="display: flex; gap: 8px;">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('from_date')}}</label>
                                    <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
                                </div>
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('to_date')}}</label>
                                    <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
                                </div>
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('status')}}</label>
                                    <select class="form-control form-control-sm" v-model="query.Status" @change="toList">
                                        <option value="">{{$t('all')}}</option>
                                        <option value="Draft">Draft</option>
                                        <option value="Posted">Posted</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('sale_reputation')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="query.EmployeeId" @change="toList">
                                            <option value="">{{$t('all')}}</option>
                                            <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Num}} : {{ret.KhmerName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="label-control blue">&nbsp;</label>
                                    <div>
                                        <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <input type="checkbox" class="btn btn-default btn-sm" v-model="query.ShowAll" /> {{$t('all')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor table-scroll">
                        <thead>
                        <tr>
                            <th class="width-column">{{ $t('no') }}</th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Num')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Date')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('AccountName')">{{ $t('income_type') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Description')">{{ $t('description') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('EmployeeName')">{{ $t('sale_reputation') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('DocSourceNo')">{{ $t('ref_num') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Amount')">{{ $t('amount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Status')">{{ $t('status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td>{{index+1}}</td>
                                <td>
                                    <router-link :to="{ name: 'sale_receipt_preview', params:{ id:ret.Id }}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.AccountName}}</td>
                                <td>{{ret.Description}}</td>
                                <td>{{ret.EmployeeName}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td class="text-right">{{$money(ret.Amount)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="7"></th>
                                <th class="text-right">{{$money(summary.Total)}}</th>
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.ShowAll?0:query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Status: 'Draft',
                    EmployeeId: '',
                    ShowAll: false
                },
                employees: [],
                records:[],
                summary: {
                    Total: 0
                }
            }
        },
        created: function(){
            this.listEmployee();
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.query.Limit = this.query.ShowAll?0:25;
                this.$api().post('sale/receipts', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.query.Total = res.data.Total;
                        this.calculate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let total = 0;
                this.records.forEach(item => {
                    total += item.Amount;
                });
                this.summary.Total = total;
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'sale/receipts/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sale-receipts.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            listEmployee(){
				this.$api().post('employees', { Limit: 0 }).then(res => {
					this.employees = res.data.Data;
				});
			}
        }
    }
</script>
